:host {
  max-width: 108px;
  height: auto;
  padding-right: calc(var(--spacer) * 1.5);
}

.grid-edit-buttons {
  .grid-edit-button {
    height: calc(3 * var(--spacer));
  }
}

.spinner {
  width: auto;
  height: calc(2 * var(--spacer));
}

.inline-menu-trigger {
  display: flex;
}
